import { createContext as t } from "react";
const e = t(null);
export {
  e as PlatformApiContext
};
